'use strict';

module.exports = function uniqueString(optional) {
	const uuid = (optional && optional.uuid) || require('uuid'),
		filename = uuid.v1();
	if (optional && optional.keepDashes) {
		return filename;
	}
	return filename.replace(/-/g, '');
};
